import { forwardRef } from "react";
import "./Button.css";

const Button = forwardRef(function Button(
  {
    variant = "primary",
    size = "md",
    active = false,
    disabled = false,
    className = "",
    children,
    ...rest
  },
  ref
) {
  const classes = [
    "btn",
    variant ? `btn--${variant}` : "",
    `btn--${size}`,
    active ? "btn--active" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button ref={ref} className={classes} disabled={disabled} {...rest}>
      {children}
    </button>
  );
});

export default Button;
